if (!customElements.get('td-pdp-ugc')) {
  class TdPdpUgc extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('.td-pdp-ugc__carousel');
      if (!this.carousel) return;
      this.watchToggles();
      this.watchDesignMode();
      this.initWhenReady();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onSectionSelect) document.removeEventListener('shopify:section:select', this.onSectionSelect);
      if (this.swiper) this.swiper.destroy(true, true);
      if (this.readyTimer) clearTimeout(this.readyTimer);
    }

    watchDesignMode() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      const section = this.closest('.shopify-section');
      if (!section) return;
      this.onSectionSelect = (event) => {
        if (!section.contains(event.target)) return;
        setTimeout(() => {
          section.querySelectorAll('modal-content.td-pdp-ugc__modal').forEach((modal) => {
            modal.open = false;
          });
        }, 0);
      };
      document.addEventListener('shopify:section:select', this.onSectionSelect);
    }

    watchToggles() {
      const toggles = this.querySelectorAll('[data-td-ugc-play]');
      if (!toggles.length) return;
      this.observer = new MutationObserver((records) => {
        records.forEach((record) => this.syncVideo(record.target));
      });
      toggles.forEach((toggle) => {
        this.observer.observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] });
      });
    }

    syncVideo(toggle) {
      const modal = document.getElementById(toggle.getAttribute('aria-controls') || '');
      const video = modal && modal.querySelector('video');
      if (!video) return;
      if (toggle.getAttribute('aria-expanded') === 'true') {
        const started = video.play();
        if (started && typeof started.catch === 'function') started.catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }

    initWhenReady(attempts) {
      if (typeof window.Swiper !== 'function') {
        const tries = attempts || 0;
        if (tries < 100) this.readyTimer = setTimeout(() => this.initWhenReady(tries + 1), 50);
        return;
      }
      const prevEl = this.querySelector('[data-td-ugc-prev]');
      const nextEl = this.querySelector('[data-td-ugc-next]');
      const scrollbarEl = this.querySelector('.td-pdp-ugc__progress');
      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        grabCursor: true,
        watchOverflow: true,
        longSwipesRatio: 0.15,
        breakpoints: {
          1000: {
            spaceBetween: 24,
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60
          }
        }
      };
      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl, disabledClass: 'td-pdp-ugc__arrow--disabled' };
      }
      if (scrollbarEl) {
        config.scrollbar = { el: scrollbarEl, draggable: true };
      }
      this.swiper = new window.Swiper(this.carousel, config);
    }
  }

  customElements.define('td-pdp-ugc', TdPdpUgc);
}
